// {
//   "name": "iconic-sections.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

// Element animation
function fadeInElements() {
  document.querySelectorAll('[data-fade-in]').forEach((element) => {
    if (isInViewport(element) && !element.classList.contains('fade-in')) {
      element.classList.add('fade-in');
    }
  });
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

  // Check if any part of the element is visible in the viewport
  const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
  const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

  return (vertInView && horInView);
}

// Observe the DOM for changes
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    fadeInElements();
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true, // Observe attribute changes
  characterData: true // Observe changes to text content
});

document.addEventListener('DOMContentLoaded', () => {
  fadeInElements(); // Call on DOMContentLoaded to handle initial state
  ['load', 'scroll', 'shopify:section:load'].forEach((eventName) => {
      window.addEventListener(eventName, fadeInElements);
  });
});